import React, { Component } from 'react';

import EditNameInfo from './EditNameInfo';
import EditAddressInfo from './EditAddressInfo';
import UserService from '../../../Service/UserService';
import { hot } from 'react-hot-loader';

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false
		};
	}

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	updateUserInfo = async user => {
		try {
			this.startLoader();
			const response = await UserService.updateUserInfo(user);
			if (response.status) {
				const updatedUser = await UserService.updateCurrentUser();
				await this.props.setCurrentUser(updatedUser);
			}
			this.props.closeProfileScreen();
			this.stopLoader();
		} catch (error) {
			console.log(error);
			this.stopLoader();
		}
	};

	render() {
		if (this.props.openScreen === 'NAME_INFO') {
			return (
				<EditNameInfo
					closeProfileScreen={this.props.closeProfileScreen}
					isLoading={this.state._isLoading}
					onSubmit={this.updateUserInfo}
					user={this.props.user}
				/>
			);
		} else {
			return (
				<EditAddressInfo
					closeProfileScreen={this.props.closeProfileScreen}
					isLoading={this.state._isLoading}
					onSubmit={this.updateUserInfo}
					supportedStates={this.props.supportedStates}
					user={this.props.user}
				/>
			);
		}
	}
}

export default hot(module)(index);
